import React, { Suspense, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { CleanResizeObserver } from "utils/resizeObserver";
import ApplicationWrapper from "./AppWrapper";
import LoadingPage from "./LoadingPage";

export default function Base(): React.ReactElement {
  useEffect(() => {
    CleanResizeObserver();
  }, []);

  return (
    <ApplicationWrapper>
      <Suspense fallback={<LoadingPage />}>
        <Outlet />
      </Suspense>
    </ApplicationWrapper>
  );
}
